import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer as App } from './app/AppContainer';
import { InitialView } from './initialView/InitialViewContainer';
import Welcome from './jointholders/welcome';
import { StepsView } from './StepsView/StepsView';
import { ContinueOnboarding } from 'components/continueOnboarding/ContinueOnboarding';
import { LogoutView } from './LogoutView/LogoutView';
import NewProducts from './messagesView/newProductsView';
import JointJolderErrorView from './messagesView/jointJolderErrorView';
import { ErrorsView } from './messagesView/errorsViewDeprecated';
import Error404View from './messagesView/error404View';
import { LoginContainer as Login } from 'components/login/LoginContainer';
import { BASE_PATH } from 'constants/index';
import ClientLogin from 'components/jointHolders/clientLogin';
import { SignComponent } from 'components/signComponent/signComponent';
import {
    CREDIT_CARD_PATH,
    VANITY_FAIR_CARD_PATH,
    EL_HORMIGUERO_CARD_PATH,
    CREDIT_CARD_LIGHT_PATH,
    VANITY_FAIR_CARD_LIGHT_PATH,
    EL_HORMIGUERO_CARD_LIGHT_PATH,
    LOAN_PATH,
} from '../constants/pathInvestments';
import { AresApp } from '../ares/app';
import InitialViewWithModal from './initialView/InitialViewWithModal';
import { LocalStorageStorage } from 'utilities/Storage/LocalStorageStorage';
import { VideoSelfieCaptureView } from 'routes/VideoSelfieCaptureView/VideoSelfieCaptureView';
import { VIDEO_SELFIE_CAPTURE_VIEW_PATH } from 'components/newIdentifyMethods/VideoScreen/VideoScreenDispatcher/VideoSelfie/constants';

export const getRoutes = () => {
    const basePath = BASE_PATH !== '' ? BASE_PATH : '/';

    return (
        <>
            <Route name="App" path={BASE_PATH}>
                <App>
                    <Switch>
                        <Route name="initial" exact path={basePath} component={InitialView} />
                        <Route name="steps" exact path={`${basePath}/steps`} component={StepsView} />
                        <Route name="step" path={`${basePath}/steps/:contractToken`} component={ContinueOnboarding} />
                        <Route
                            name="login"
                            path={`${basePath}/login/:token`}
                            render={props => <Login {...props} storage={LocalStorageStorage()} />}
                        />
                        <Route name="promoCode" exact path={`${basePath}/promo-code/:code`} component={InitialView} />
                        <Route
                            name="promoCode"
                            path={`${basePath}/promo-code/:code/ISIN/:isin`}
                            component={InitialView}
                        />
                        <Route
                            name="promoCode"
                            path={`${basePath}/promo-code/:code/DGS/:dgs`}
                            component={InitialView}
                        />
                        <Route
                            name="promoCode"
                            path={`${basePath}/promo-code/:code/INVD/:invd`}
                            component={InitialView}
                        />
                        <Route name="robo" path={`${basePath}/inversion-automatizada`} component={InitialView} />
                        <Route
                            name="creditCard"
                            path={[
                                `${basePath}/${CREDIT_CARD_PATH}`,
                                `${basePath}/${CREDIT_CARD_LIGHT_PATH}`,
                                `${basePath}/${VANITY_FAIR_CARD_PATH}`,
                                `${basePath}/${VANITY_FAIR_CARD_LIGHT_PATH}`,
                                `${basePath}/${EL_HORMIGUERO_CARD_PATH}`,
                                `${basePath}/${EL_HORMIGUERO_CARD_LIGHT_PATH}`,
                            ]}
                            component={InitialView}
                        />
                        <Route name="gbi" path={`${basePath}/inversion-por-objetivos`} component={InitialView} />
                        <Route
                            name="welcomeJointHolder"
                            path={`${basePath}/cuentaconjunta/bienvenida/:token`}
                            component={Welcome}
                        />
                        <Route name="logout" path={`${basePath}/logout`} component={LogoutView} />
                        <Route name="newProducts" path={`${basePath}/newProducts`} component={NewProducts} />
                        <Route
                            name="jointJolderErrorView"
                            path={`${basePath}/cuentaconjunta/error`}
                            component={JointJolderErrorView}
                        />
                        <Route name="errors" path={`${basePath}/errors`} component={ErrorsView} />
                        <Route name="universia" path={`${basePath}/universia/:id`} component={InitialViewWithModal} />
                        <Route name="clientLogin" path={`${basePath}/cuentaconjunta/login`} component={ClientLogin} />
                        <Route name="singComplete" path={`${basePath}/firma`} component={SignComponent} />
                        <Route name="Ares" path={`${basePath}/${LOAN_PATH}`} component={AresApp} />
                        <Route
                            name="AresContract"
                            path={`${basePath}/${LOAN_PATH}/:contractToken`}
                            component={ContinueOnboarding}
                        />
                        <Route
                            name="VideoSelfieCapture"
                            path={`${basePath}/${VIDEO_SELFIE_CAPTURE_VIEW_PATH}/:token/:id`}
                            component={VideoSelfieCaptureView}
                        />
                        <Route name="404" path="*" component={Error404View} />
                    </Switch>
                </App>
            </Route>
        </>
    );
};
